// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { TxnDetail } from './txn-detail';
import { TxnHeader } from './txn-header';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TxnBatch extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  txnBatchId!: number;
  accountBalance?: number;
  accountFacilityName?: string;
  accountFacilityNumber?: string;
  accountId?: number;
  balanceDate?: Date;
  batchCreditAmount?: number;
  batchCreditTransactions?: number;
  batchDebitAmount?: number;
  batchDebitTransactions?: number;
  batchReferenceNumber?: string;
  batchType?: string;
  bsbnumber?: string;
  debitCreditIndicator?: string;
  txnHeaderId!: number;
  txnDetails!: TxnDetail[];
  txnHeader!: TxnHeader;
}

